// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BtF-w","col":"styles_col__ACbpY"};